import { id } from "date-fns/locale";
import axiosApiInstance from "../../../helpers/interceptor";

const urlTest = "http://localhost:5001";
const url =
  import.meta.env.VITE_APP_EXTERNAL_URL ||
  "https://api.inteligenciafuentes.anteia.co";

const startConsultPath = "api/startConsultation";
const filteredConsultationsPath = "api/getFilteredConsultations";
const getConsultationPath = (id: string) => `api/getConsultationDetail/${id}`;
const retryConsultationPath = (id: string) => `api/retryConsultation/${id}`;
const getPdfReportPath = (id: string) => `api/getPdfReport/${id}`;
const getPdfTusDatosPath = (id: string, type: "PERSON" | "VEHICLE") =>
  `api/getPDFReportByConsultId/${id}/${type}`;
const getConsultationsByExecFlowId = (id: string) =>
  `api/getConsultationsDetailByExternalId/${id}`;

export const startConsultationAPI = async (req: StartConsultationReq) => {
  try {
    const response = await axiosApiInstance.post<ConsultationResultDetail>(
      `${url}/${startConsultPath}`,
      req
    );
    return {
      data: response.data,
      error: "",
    };
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      } else if (err.response.status === 400)
        return { error: "Error de validación" };
      else if (err.response.status === 401) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else if (err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else {
        return { error: "Error inesperado" };
      }
    } else {
      return { error: err.message as string };
    }
  }
};

export const getFilteredConsultationsAPI = async (
  req: FilterConsultationsReq
) => {
  try {
    const response = await axiosApiInstance.post<ConsultationFilteredResult>(
      `${url}/${filteredConsultationsPath}`,
      req
    );
    return {
      data: response.data,
      error: "",
    };
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      } else if (err.response.status === 400)
        return { error: "Error de validación" };
      else if (err.response.status === 401) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else if (err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else {
        return { error: "Error inesperado" };
      }
    } else {
      return { error: err.message as string };
    }
  }
};

export const getConsultationDetailAPI = async (id: string) => {
  try {
    const response = await axiosApiInstance.get<ConsultationResultDetail>(
      `${url}/${getConsultationPath(id)}`
    );
    return {
      data: response.data,
      error: "",
    };
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      } else if (err.response.status === 400)
        return { error: "Error de validación" };
      else if (err.response.status === 401) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else if (err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else {
        return { error: "Error inesperado" };
      }
    } else {
      return { error: err.message as string };
    }
  }
};

export const getConsultationDetailByExecFlowIdAPI = async (id: string) => {
  try {
    const response = await axiosApiInstance.get<ConsultationResultDetail[]>(
      `${url}/${getConsultationsByExecFlowId(id)}`
    );
    return {
      data: response.data,
      error: "",
    };
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      } else if (err.response.status === 400)
        return { error: "Error de validación" };
      else if (err.response.status === 401) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else if (err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else {
        return { error: "Error inesperado" };
      }
    } else {
      return { error: err.message as string };
    }
  }
};

export const retryConsultationAPI = async (id: string) => {
  try {
    const response = await axiosApiInstance.get<ConsultationResultDetail>(
      `${url}/${retryConsultationPath(id)}`
    );
    return {
      data: response.data,
      error: "",
    };
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      } else if (err.response.status === 400)
        return { error: "Error de validación" };
      else if (err.response.status === 401) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else if (err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else {
        return { error: "Error inesperado" };
      }
    } else {
      return { error: err.message as string };
    }
  }
};

export const getPdfReportAPI = async (id: string) => {
  try {
    const response = await axiosApiInstance.get(
      `${url}/${getPdfReportPath(id)}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      } else if (err.response.status === 400)
        return { error: "Error de validación" };
      else if (err.response.status === 401) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else if (err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      } else {
        return { error: "Error inesperado" };
      }
    } else {
      return { error: err.message as string };
    }
  }
};

export const getPdfTusDatosAPI = async (
  id: string,
  type: "PERSON" | "VEHICLE"
) => {
  try {
    const response = await axiosApiInstance.get(
      `${url}/${getPdfTusDatosPath(id, type)}`,
      {
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
        },
      }
    );

    const filename =
      getFilenameFromContentDisposition(
        response.headers["content-disposition"]
      ) ?? `tusdatos-${type.toLowerCase()}-${id}.pdf`;

    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/pdf",
    });

    downloadBlob(blob, filename);

    return {
      success: true,
      filename,
    };
  } catch (err: any) {
    if (err.response) {
      if (err.response.status === 500) {
        return { error: "Error de servidor" };
      }

      if (err.response.status === 400) {
        return { error: "Error de validación" };
      }

      if (err.response.status === 401 || err.response.status === 403) {
        return {
          error: "No tienes permisos para realizar esta acción",
        };
      }

      return { error: "Error inesperado" };
    }

    return { error: err.message as string };
  }
};

function getFilenameFromContentDisposition(
  contentDisposition: string | undefined
): string | null {
  if (!contentDisposition) return null;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);

  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

  if (filenameMatch?.[1]) {
    return filenameMatch[1];
  }

  return null;
}

function downloadBlob(blob: Blob, filename: string) {
  const objectUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}
export interface StartConsultationReq {
  type: "PERSON" | "VEHICLE";
  identification?: string;
  international?: boolean;
  placa?: string;
  fechaExpedicion?: string;
  name?: string;
  identificationType: "CC" | "CE" | "NIT" | "PP" | "PPT";
}

export interface ConsultationResultDetail {
  id: string;
  externalId: string;
  personType?:
    | "CONDUCTOR"
    | "TENEDOR"
    | "VEHICULO"
    | "PROPIETARIOREMOLQUE"
    | "PROPIETARIOVEHICULO"
    | "REMOLQUE";
  status: "started" | "finished" | "error";
  personConsult?: PersonConsult;
  vehicleConsult?: VehicleConsult;
  executingRetry: boolean;
  result?: ConsultationResultData;
  createdAt: string;
  updatedAt: string;
  consultId?: string;
}

export interface PersonConsult {
  name: string;
  identification: string;
  identificationType: string;
  constultedByEmail: string;
  fechaExpedicion?: string;
}

export interface VehicleConsult {
  tecnomecanica: RevisionTM;
  soat: Soat;
  infoVehiculo: InfoVehiculo;
  ownerIdentification: string;
  ownerIdentificationType: string;
}
export interface RevisionTM {
  fechaRevision: string;
  fechaVencimiento: string;
  noRevision: string;
  placa?: string;
  reqrtm?: boolean;
  valido: boolean | string;
  vigente: boolean;
  cda?: string;
}

export interface Soat {
  fechaExpedicion: string;
  fechaInicio: string;
  fechaVencimiento: string;
  noSoat: string;
  valido: boolean;
  vigente: boolean;
}

export interface InfoVehiculo {
  placa: string;
  color: string;
  fmatri: string;
  linea: string;
  marca: string;
  estado: string;
  valido: boolean;
}

export interface FilterConsultationsReq {
  page: number;
  pageSize?: number;
  status?: "started" | "finished";
  startDate?: string;
  endDate?: string;
}

export interface ConsultationFilteredResult {
  numPages: number;
  consultations: ConsultationResultItem[];
}

export interface ConsultationResultItem {
  id: string;
  externalId: string;
  identification?: string;
  identificationType?: string;
  placa?: string;
  name?: string;
  status: "started" | "finished" | "error";
  createdAt: string;
}

export interface ConsultationResultData {
  actividades_economicas?: string[];
  categoria_matricula?: string;
  clase_identificacion?: string;
  codigo_camara?: string;
  codigo_estado?: string;
  concordato?: boolean;
  contadores_s?: any[];
  contaduria?: boolean;
  contaduria_data?: ContaduriaData[];
  contaduria_hallazgo?: string;
  contaduria_pdf?: string;
  contraloria?: any;
  defunciones_registraduria?: DefuncionesRegistraduria;
  delitos_sexuales?: any[];
  dest?: string;
  dict_hallazgos?: DictHallazgos;
  error: boolean;
  errores: string[];
  europol?: any[];
  fecha: string;
  fecha_expedicion?: boolean;
  fopep?: any;
  garantias_mobiliarias?: GarantiaMobiliaria[];
  genero?: string;
  hallazgos?: string;
  iadb?: any;
  id: number;
  inpec?: any;
  insolvencias?: any[];
  interpol?: boolean | any[] | string;
  juzgados?: any[];
  juzgados_tyba?: any[];
  libretamilitar?: LibretaMilitar;
  lista_banco_mundial?: ListaBancoMundial;
  lista_onu?: boolean | any[] | string;
  monitoring_date: any;
  nombre: string;
  "nombre-procuraduria": string;
  ofac?: boolean | any[] | string;
  ofac_nombre?: any;
  omisiones_vehiculos?: string;
  offshoreleaks?: OffshoreLeaks;
  paco_online?: any[];
  peps?: any[];
  peps_consolidado?: PepsConsolidado[];
  peps_denom?: any;
  peps_version?: string;
  policia?: string | boolean;
  procuraduria?: any;
  profesion?: Profesion;
  proveedores_ficticios?: any;
  rama?: Rama;
  rama_unificada?: RamaUnificada[];
  estado?: string;
  estadoRM?: string;
  identificacion?: string;
  matricula?: string | MatriculaEstado;
  municipio?: string;
  nit?: number;
  nombre_camara?: string;
  organizacion_juridica?: string;
  propietario_o_establecimientos_agencias_sucursales?: any[];
  radicaciones_sic?: any[];
  razon_social?: string;
  registro_mercantil?: RegistroMercantil;
  renovaciones_anteriores?: RenovacionAnterior[];
  representacion_legal?: string;
  representacion_legal_y_vinculos?: RepresentanteLegalVinculo[];
  reputacional?: Reputacional | string;
  rndc?: Rndc[];
  rnmc?: any;
  ruaf?: Ruaf;
  rues?: boolean;
  sena?: Sena[];
  sirna?: any[];
  tipo?: string;
  runt_app?: RuntApp;
  rut?: string;
  rut_estado?: string;
  secop?: any[];
  secop2?: any[];
  secop_s?: any[];
  simit?: Simit;
  simur?: Simur[];
  soat?: Soat;
  typedoc?: string;
  accidentalidad_bog?: AccidenteBog[];
  impuesto_bogota?: RespuestaSimple[];
  impuestos_antioquia?: RespuestaSimple[];
  impuestos_atlantico?: RespuestaSimple[];
  impuestos_bolivar?: RespuestaSimple[];
  impuestos_cauca?: RespuestaSimple[];
  impuestos_cundinamarca?: RespuestaSimple[];
  impuestos_magdalena?: RespuestaSimple[];
  impuestos_nte_santander?: RespuestaSimple[];
  impuestos_risaralda?: RespuestaSimple[];
  impuestos_santander?: RespuestaSimple[];
  impuestos_valle?: RespuestaSimple[];
  runt?: RuntData;
  vehiculo?: VehiculoResult;
}

export interface VehiculoResult {
  autoridad_de_transito: string;
  licencia: string;
  clase: string;
  placa: string;
  color: string;
  fmatri: string;
  linea: string;
  marca: string;
  modelo: string;
  estado: string;
  valido: boolean;
  tipo_servicio: string;
}
export interface Rama {
  armeniajepms: JEPMSRadicados;
  barranquillajepms: JEPMSRadicados;
  bogotajepms: JEPMSRadicados;
  bucaramangajepms: JEPMSRadicados;
  bugajepms: JEPMSRadicados;
  calijepms: JEPMSRadicados;
  cartagenajepms: JEPMSRadicados;
  florenciajepms: JEPMSRadicados;
  ibaguejepms: JEPMSRadicados;
  ladoradajepms: JEPMSRadicados;
  manizalesjepms: JEPMSRadicados;
  medellinjepms: JEPMSRadicados;
  monteriajepms: JEPMSRadicados;
  neivajepms: JEPMSRadicados;
  palmirajepms: JEPMSRadicados;
  pastojepms: JEPMSRadicados;
  pereirajepms: JEPMSRadicados;
  popayanjepms: JEPMSRadicados;
  quibdojepms: JEPMSRadicados;
  santamartajepms: JEPMSRadicados;
  tunjajepms: JEPMSRadicados;
  valleduparjepms: JEPMSRadicado;
  villavicenciojepms: JEPMSRadicados;
}

export interface JEPMSRadicados {
  [radicacion: string]: JEPMSRadicado;
}

export interface JEPMSRadicado {
  actuaciones: Actuacion[];
  alias: string;
  apellidos: string;
  "autoridades que conocieron": Autoridad[];
  "clase proceso": ClaseProceso;
  condenados: Condenado[];
  "datos sentencia": DatosSentencia;
  delitos: string;
  dirección: string;
  "estado civil": string;
  estudios: any;
  "fecha nacimiento": string;
  "juzgado jepms": JuzgadoJepms;
  link: string;
  "lugar nacimiento": string;
  multa: string;
  "no identificación": string;
  "nombre padres": string;
  nombres: string;
  "numero unico radicacion": NumeroUnicoRadicacion;
  observaciones: string;
  pantalla: string;
  pantallap: string;
  "pena privativa de la libertad": PenaPrivativaLibertad;
  "penas acumuladas": PenasAcumuladas;
  "privado de la libertad": string;
  "privado de la libertad desde": string;
  "requerido por otra(s) autoridad(es)": string;
  telefono: string;
}

export interface Actuacion {
  anotacion: string;
  cuadernos: string;
  fecha: string;
  folio: string;
  tipo: string;
}

export interface Autoridad {
  autoridad: string;
  radicacion: string;
}

export interface ClaseProceso {
  clase: string;
}

export interface Condenado {
  identificacion: string;
  "nombre del condenado": string;
}

export interface DatosSentencia {
  Instancia_Falladora: string;
}

export interface JuzgadoJepms {
  ciudad: string;
}

export interface NumeroUnicoRadicacion {
  radicacion: string;
}

export interface PenaPrivativaLibertad {
  años: string;
  dias: string;
  meses: string;
}

export interface PenasAcumuladas {
  penas_acumuladas: string;
}

export interface ContaduriaData {
  entidad_reportante: string;
  estado: string;
  fecha_corte: string;
  nombre_reportado: string;
  numero_obligacion: string;
}

export interface DefuncionesRegistraduria {
  date: string;
  doc: number;
  validity: string;
}

export interface DictHallazgos {
  altos: Hallazgo[];
  bajos: Hallazgo[];
  infos: Hallazgo[];
  medios: Hallazgo[];
}

export interface Hallazgo {
  cantidad: string;
  codigo: string;
  coincidencia: string;
  descripcion: string;
  fuente: string;
  hallazgo: string;
  html_id: string | null;
}
export interface LibretaMilitar {
  info: string;
}

export interface LibretaMilitarDetalle {
  clase: string;
  documento: string;
  nombre: string;
  tipo_documento: string;
}

export interface ListaBancoMundial {
  debarred_firms_individuals: any;
  others_sanctions: any;
}
export interface OffshoreLeaks {
  "Bahamas Leaks": any;
  "Offshore Leaks": any;
  "Panama Papers": any;
  "Pandora Papers": any;
  "Paradise Papers": any;
}
export interface PepsConsolidado {
  categoria: string;
  nombre_lista: string;
  origen: string;
  tipo_lista: string;
}
export interface Profesion {
  abogados_judicial: AbogadoJudicial[];
  conaltel: any;
}

export interface AbogadoJudicial {
  message: string;
}
export interface RamaUnificada {
  actuaciones: Actuacion[];
  cantFilas: number;
  claseProceso: string;
  contenidoRadicacion: string;
  demandado: string[];
  demandante: string[];
  departamento: string;
  despacho: string;
  detalle: any;
  dict_data_extra: any;
  esPrivado: boolean;
  estado_actuacion: string;
  fechaConsulta: string;
}

export interface Actuacion {
  actuacion: string;
  anotacion: string;
  cant: number;
  codRegla: string;
  conDocumentos: any;
  consActuacion: number;
  fechaActuacion: string;
  fechaFinal: string;
  fechaInicial: string;
  fechaRegistro: string;
  idRegActuacion: number;
  llaveProceso: string;
}

export interface RegistroMercantil {
  categoria_de_la_matricula: string;
  estado_de_la_matricula: string;
  fecha_de_matricula: string;
  fecha_de_renovacion: string;
  fecha_de_vigencia: string;
  numero_de_matricula: string;
  tipo_de_organización: string;
  tipo_de_sociedad: string;
  último_año_renovado: string;
}
export interface RenovacionAnterior {
  años: string;
  fecha_renovación: string;
}
export interface RepresentanteLegalVinculo {
  estado_consulta: string;
  hallazgo: string;
  "no identificación": string;
  nombre: string;
  report_date: string;
  reporte: string;
  "tipo de vinculo": string;
  typedoc: string;
}

export interface Reputacional {
  news: NewsItem[];
  notable: Notable;
  social: any[]; // Assuming structure is not yet defined
}

export interface NewsItem {
  description: string;
  idioma: string;
  keyword: string;
  link: string;
  news_source: string;
  sentimiento: string;
  title: string;
}

export interface Notable {
  Descripción: string;
  Nombre: string;
}

export interface Rndc {
  "Cedula Conductor": string;
  Consecutivo: string;
  Destino: string;
  Estado: string;
  "Fecha Exped": string;
  "Fecha Hora Radicación": string;
  "Nombre Empresa Transportadora": string;
  "Nro de Radicado": string;
  Origen: string;
  Placa: string;
  "Placa Remolque": string;
  "Tipo Doc": string;
}

export interface RuntApp {
  exitoso: boolean;
  licencia?: LicenciaData;
  multa?: MultaData;
  nombres: string;
}

export interface LicenciaData {
  licencias?: Licencia[];
  totalLicencias: number;
}

export interface Licencia {
  categoria: string;
  estado: string;
  fecha_expedicion: string;
  fecha_vencimiento: string;
  numero_licencia: string;
  sustrato: string;
}

export interface MultaData {
  estado_cancelacion: string;
  estado_paz_salvo: string;
  estado_suspension: string;
  fecha_cancelacion: string;
  fecha_suspension: string;
  numero_comparendos: string;
  numero_paz_salvo: string;
}
export interface Sena {
  Certificación: string;
  Descarga: string;
  "Estado de Certificación": string;
  "Estado del Aprendiz": string;
  Programa: string;
  Registro: string;
  Tipo: string;
}
export interface Simit {
  acuerdos_pagar: number;
  acuerdos_pagos: any[];
  cantidad_multas: number;
  cursos: CursoSimit[];
  multas: MultaSimit[];
  numero_documento: string;
  paz_salvo: boolean;
  total_acuardos_por_pagar: number;
  total_general: number;
  total_multas: number;
  total_multas_pagar: number;
  total_pagar: number;
}

export interface CursoSimit {
  centro_intruccion: string;
  certificado: string;
  cuidad: string;
  estado: string;
  fecha_comparendo: string | null;
  fecha_curso: string;
  fecha_reporte: string;
  numero_multa: string;
}

export interface MultaSimit {
  comparendo: boolean;
  comparendo_electronico: boolean;
  consecutivo_comparendo: string | null | number;
  departamento: string;
  estado: string | null;
  fecha_comparendo: string;
  fecha_notificacion: string | null;
  infraciones: Infraccion[];
  infractor: Infractor;
  numero_comparendo: string;
  organismo_transito: string;
  placa: string;
  total_pagar: number;
  valor_descuento: number;
  valor_descuento_interes: number;
  valor_descuento_pronto_pago: number;
  valor_interes: number;
  valor_multa: number;
}

export interface Infraccion {
  codigo: string;
  descripcion: string;
  valor: number;
}

export interface Infractor {
  apellidos: string;
  documento: string;
  nombres: string;
  tipo_documento: string;
}

export interface Simur {
  "Estado comparendo"?: string;
  "Fecha Infraccion"?: string;
  Infractor?: string;
  Intereses?: number;
  "No Comparendo"?: string;
  Placa?: string;
  Saldo?: number;
  Tipo?: string;
  "Total saldo + intereses"?: number;
}

export interface AccidenteBog {
  Fecha: string;
  Formulario: string;
  Gravedad: string;
}

export interface RespuestaSimple {
  Response: string;
}

export interface MatriculaEstado {
  estado_matricula: string;
}
export interface RuntData {
  antiguo: string;
  autoridad_de_transito: string;
  carroceria: string;
  cilindraje: string;
  clase_vehiculo: string;
  color: string;
  combustible: string;
  estado: string;
  fmatri: string;
  gravamenes: string;

  info_a_desintegrar: any[];

  info_blindaje: InfoBlindaje;
  info_cert_desintegracion: InfoCertDesintegracion;
  info_dijin: InfoDijin;

  info_garantias_a_favor: InfoGarantiaFavor[];
  info_garantias_mobiliarias: any[];

  info_limitacion_propiedad: InfoLimitacionPropiedad[];

  info_normalizacion: InfoNormalizacion[];

  info_operacion: InfoOperacion;

  info_permiso_circulacion: any[];

  info_poliza_caucion: InfoPolizaCaucion;

  info_registro_inicial: InfoRegistroInicial;
  info_registro_inicial_invc: InfoRegistroInicialInvc;

  info_responsabilidad: any[];
  info_revision_ambiental: any[];

  info_soat: InfoSoat[];

  info_solicitudes: InfoSolicitud[];

  info_tecnica: InfoTecnica;

  info_tecnico_mecanica: InfoRevisionTecnicoMecanica[];

  licencia: string;
  linea: string;
  marca: string;
  modelo: string;

  num_chasis: string;
  num_motor: string;
  num_re_chasis: string;
  num_re_motor: string;
  num_re_serie: string;
  num_re_vin: string;
  num_serie: string;
  num_vin: string;

  placa: string;
  puertas: string;

  regrabacion_chasis: string;
  regrabacion_motor: string;
  regrabacion_serie: string;
  regrabacion_vin: string;

  repotenciado: string;
  tipo_servicio: string;
  veh_enseñanza: string;
}

export interface InfoBlindaje {
  blindado: string;
  fecha_blindaje: string;
  fecha_desblindaje: string;
  nivel_blindaje: string;
}

export interface InfoCertDesintegracion {
  entidad_desintegradora: string;
  estado_certificado: string;
  fecha_exp: string;
  num_certificacion: string;
}

export interface InfoDijin {
  entidad_emite: string;
  estado_certificado: string;
  fecha_exp: string;
  num_certificado: string;
}

export interface InfoGarantiaFavor {
  acreedor: string;
  confecamaras: string;
  fecha_inscripcion: string;
  identificacion_acreedor: string;
  patrimonio_autonomo: string;
}

export interface InfoLimitacionPropiedad {
  departamento: string;
  entidad_juridica: string;
  fecha_exp_oficio: string;
  fecha_registro: string;
  municipio: string;
  numero_oficio: string;
  tipo_limitacion: string;
}

export interface InfoNormalizacion {
  deficiencia_matricula: string;
  descargar_documento: string;
  fecha_normalizacion: string;
  nro_acto_administrativo: string;
  vehiculo_normalizado: string;
}

export interface InfoOperacion {
  emp_afiliadora: string;
  estado: string;
  fecha_exp: string;
  fecha_fin_vigencia: string;
  fecha_inicio_vigencia: string;
  modalidad_serv: string;
  modalidad_transp: string;
  num_tarjeta: string;
  radio_accion: string;
}

export interface InfoPolizaCaucion {
  estado_certificado: string;
  estado_poliza: string;
  fecha_exp_poliza: string;
  fecha_vigencia_poliza: string;
  num_certificado: string;
  num_poliza: string;
}

export interface InfoRegistroInicial {
  estado_certificado: string;
  fecha_exp: string;
  num_certificado: string;
  placas_reposicion: string;
}

export interface InfoRegistroInicialInvc {
  estado_certificado: string;
  fecha_exp: string;
  num_certificado: string;
}

export interface InfoSoat {
  codigo_tarifa: string;
  entidad_expide: string;
  estado: string;
  fecha_expedicion: string;
  fecha_fin: string;
  fecha_inicio: string;
  no_soat: string;
}

export interface InfoSolicitud {
  entidad: string;
  estado: string;
  fecha_solicitud: string;
  nro_solicitud: string;
  tramites: string;
}

export interface InfoTecnica {
  capacidad: string;
  capacidad_pasajeros: string;
  capacidad_pasajeros_sentados: string;
  num_ejes: string;
  peso_bruto: string;
}

export interface InfoRevisionTecnicoMecanica {
  acciones: string;
  cda_expide: string;
  fecha_exp: string;
  fecha_vigencia: string;
  informacion_consistente: string;
  nro_certificado: string;
  tipo_revision: string;
  vigente: string;
}

export interface Ruaf {
  ARL?: RuafArl[];
  Basico?: RuafBasico[];
  "Caja de compensación"?: any;
  Cesantías?: any;
  Pensionado?: RuafPensionado[];
  Pensiones?: RuafPensiones[];
  "Programas de Asistencia Social"?: RuafProgramas_de_asistencia_social[];
  Salud?: RuafSalud[];
}

export interface RuafArl {
  "Actividad Economica"?: string;
  Administradora?: string;
  "Estado de Afiliación"?: string;
  "Fecha de Afiliación"?: string;
  "Fecha de corte"?: string;
  "Municipio Labora"?: string;
}

export interface RuafSalud {
  Administradora?: string;
  "Departamento -> Municipio"?: string;
  "Estado de Afiliación"?: string;
  "Fecha Afiliacion"?: string;
  "Fecha de corte"?: string;
  Régimen?: string;
  "Tipo de Afiliado"?: string;
}

export interface RuafProgramas_de_asistencia_social {
  "Fecha de corte"?: string;
  "Programas de Asistencia Social"?: string;
}

export interface RuafPensiones {
  Administradora?: string;
  "Estado de Afiliación"?: string;
  "Fecha de Afiliación"?: string;
  "Fecha de corte"?: string;
  Régimen?: string;
}

export interface RuafPensionado {
  "Fecha de corte"?: string;
  Pensionado?: string;
}

export interface RuafBasico {
  Estado?: string;
  "Fecha de corte"?: string;
  "Número de Identificación"?: string;
  "Primer Apellido"?: string;
  "Primer Nombre"?: string;
  "Segundo Apellido"?: string;
  "Segundo Nombre"?: string;
  Sexo?: string;
}

export interface GarantiaMobiliaria {
  "Acreedor(es)": string;
  "Fecha de inscripción inicial": string;
  "Folio Electrónico": string;
  "Ultima Operación": string;
  Detalles: {
    Acreedor: {
      "Razón Social o Nombre": string;
      "Número de Identificación": string;
      Ciudad: string;
    };
    Deudor: {
      "Razón Social o Nombre": string;
      "Número de Identificación": string;
      Ciudad: string;
    };
    "Bienes garantizados"?: {
      Marca: string;
      "Año Correspondiente al Modelo": string;
      "Descripción del Bien": string;
    };
    "Info general": {
      "Tipo Garantía": string;
      "Monto Máximo de la obligación garantizada": string;
      "Fecha Finalización": string;
    };
  };
}
export interface Sisconmp {
  Apellidos: string;
  Clase: string;
  DCInstitucionEducativa: number;
  DIVCODIGSede: string;
  DIVNOMBRSede: string;
  DescripcionClase: string;
  EntidadCertificadora: string;
  FechaExpedicion: string; // podrías tiparlo como Date si lo transformas
  FechaExpedicionLicencia: string;
  FechaRegistro: string;
  FechaVencimiento: string;
  FechaVencimientoLicencia: string;
  Inactivo: string; // podrías usar "Si" | "No" si quieres más precisión
  InstitucionEducativa: string;
  NDI: string;
  NIDSede: string;
  NITInstitucionEducativa: number;
  NombreArchivo: string | null;
  NombreCapacitacion: string;
  NombreSede: string;
  Nombres: string;
  NumeroLicencia: string;
  TDI: string;
  TipoCapacitacion: string;
  TipoVehiculo: string;
  ValorNumericoClase: number;
}

export interface JuzgadoTybaResponse {
  juzgados_tyba?: JuzgadoTyba[];
}

export interface JuzgadoTyba {
  "CIUDAD PROCESO"?: string;
  "CLASE PROCESO"?: string;
  "CODIGO PROCESO"?: string;
  "DEPARTAMENTO PROCESO"?: string;
  DESPACHO?: string;

  "INFO PROCES0"?: InfoProceso;

  proceso_privado?: boolean;
  total_rows?: number;
}
export interface InfoProceso {
  Celular?: string;
  Ciudad?: string;
  "Clase Proceso"?: string;
  Corporación?: string;
  "Correo Electrónico Externo"?: string;
  "Código Proceso"?: string;
  Departamento?: string;
  Despacho?: string;
  Dirección?: string;
  "Distrito\\Circuito"?: string;
  Especialidad?: string;
  "Fecha Finalización"?: string;
  "Fecha Providencia"?: string;
  "Fecha Publicación"?: string;
  "Número Despacho"?: string;
  "Observaciones Finalización"?: string;
  "Subclase Proceso"?: string;
  Teléfono?: string;
  "Tipo Decisión"?: string;
  "Tipo Proceso"?: string;

  actuaciones?: Actuacion[];
  sujetos?: Sujeto[];
}
export interface Actuacion {
  CICLO?: string;
  "FECHA ACTUACIÓN"?: string;
  "FECHA DE REGISTRO"?: string;
  "TIPO ACTUACIÓN"?: string;
}
export interface Sujeto {
  "ES EMPLAZADO"?: "SI" | "NO" | string;
  "FECHA REGISTRO"?: string;
  "NOMBRE(S) Y APELLIDO(S) / RAZÓN SOCIAL"?: string;
  "NÚMERO DE IDENTIFICACIÓN"?: string;
  "TIPO DOCUMENTO"?: string;
  "TIPO SUJETO"?: string;
}

export interface AccidentalidadBogota {}

export interface ImpuestoVehiculo {
  Response?: string;
}

export interface VUSInmov {}

export interface RegistraduriaCertificado {
  cedula: string;
  estado: string;
  fecha_exp: string;
  lugar_exp: string;
  nombre: string;
}

export interface Sisben {
  "Actualizacion Ciudadano": string;
  Apellido: string;
  Departamento: string;
  Estado: string;
  Ficha: string;
  Grupo: string;
  Municipio: string;
  Nombre: string;
  "Tipo de grupo": string;
}
